import React, { useEffect } from "react";
import {
  TextField,
  Popover,
  Typography,
  makeStyles,
  Theme,
  createStyles,
  Popper,
  Card,
  MenuItem
} from "@material-ui/core";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import SelectItem from "../../../models/shared/SelectItem";

interface Props {
  label: string;
  name: string;
  minimumInputLength?: number | null;
  data: SelectItem<any>[];
  value: any;
  onChange: (name: string, value: any) => void;
}

export default function TrAutocomplete({
  data,
  value,
  onChange,
  name,
  label,
  minimumInputLength
}: Props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLInputElement | null>(null);
  const [filterCleared, setFilterCleared] = React.useState<boolean>(false);
  const [chosen, setChosen] = React.useState<boolean>(false);
  const [fieldFocus, setFieldFocus] = React.useState<boolean>(false);
  const [fieldValue, setFieldValue] = React.useState<string>("");
  const [filteredList, setFilteredList] = React.useState<SelectItem<any>[]>(
    new Array<SelectItem<any>>()
  );

  useEffect(() => {
    setTimeout(function() {
      if (
        data &&
        data.length > 0 &&
        fieldValue &&
        minimumInputLength &&
        fieldValue.length >= minimumInputLength
      ) {
        var items = data
          .filter(d => d.text.toLowerCase().includes(fieldValue.toLowerCase()))
          .slice(0, 100);
        setFilteredList(
          items.map(i => {
            return { value: i.value, text: i.text } as SelectItem<any>;
          })
        );
      } else if (data && data.length > 0 && !minimumInputLength) {
        setFilteredList(data);
      } else if (data && data.length > 0) {
        setFilteredList(new Array<SelectItem<any>>());
      }
    }, 300);
  }, [fieldValue, data]);

  useEffect(() => {
    if (data && Array.isArray(data) && value) {
      const selectedValue = data.find((d) => d.value === value);
      if (selectedValue) {
        setFieldValue(selectedValue.text);
      }
    } else if (!value && fieldValue !== "") {
      setFieldValue("");
    }
  }, [value, data]);
  

  const handleFocus = (event: React.MouseEvent<HTMLInputElement>) => {
    setAnchorEl(event.currentTarget);
    setFieldFocus(true);
  };

  const handleBlur = () => {
    setFieldFocus(false);
  };

  const handleChose = (e: any) => {
    const selectedText = e.currentTarget.innerText;
    const selectedValue = e.target.value;
  
    setFieldValue(selectedText);
    setAnchorEl(null);
    onChange(name, selectedValue);
    setChosen(true);
  };
  

  const handleTyping = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChosen(false);
    setFieldValue(e.target.value);
    if (e.target.value == null || e.target.value == "") {
      setFilterCleared(true);
    }
  };

  const handleClickAway = (e: any) => {
    if (!fieldFocus) {
      setAnchorEl(null);
    }
  
    if (filterCleared) {
      onChange(name, null);
      setFieldValue("");
      setFilterCleared(false);
    }
  };
  

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <TextField
          fullWidth
          autoComplete="off"
          type="search"
          name={name}
          value={fieldValue}
          variant={"outlined"}
          label={label}
          lang={"hr"}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleTyping}
        />
        <Popper
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          disablePortal={true}
        >
          <Card
            className={classes.popover}
            style={{
              width: anchorEl ? anchorEl.offsetWidth + "px" : "auto",
              maxWidth: anchorEl ? anchorEl.offsetWidth + "px" : "auto",
              boxSizing: "border-box"
            }}
          >
            {filteredList.length > 0 ? (
              filteredList.map(f => {
                return (
                  <MenuItem
                    value={f.value.toString()}
                    key={f.value.toString()}
                    onClick={handleChose}
                    className={classes.listItem}
                  >
                    {f.text}
                  </MenuItem>
                );
              })
            ) : minimumInputLength && fieldValue.length < minimumInputLength ? (
              <MenuItem
                onClick={e => setFieldValue("")}
                className={classes.listItem}
              >
                Potrebno je unijeti minimalno tri znaka
              </MenuItem>
            ) : (
              <MenuItem
                onClick={e => setFieldValue("")}
                className={classes.listItem}
              >
                Nema rezultata
              </MenuItem>
            )}
          </Card>
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      maxHeight: "350px",
      overflowY: "auto",
      marginLeft: "2px",
      boxShadow:
        "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)"
    },
    listItem: {
      wordBreak: "break-word",
      whiteSpace: "pre-wrap"
    }
  })
);
